<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="historicos && historicos.length">
      <px-historico :historicos="historicos" :fields="defaultFields"/>
    </div>
    <div v-if="!loading && !historicos.length"
         align="center"
         class="headline mb-5">
      Ainda não há históricos de alteração
    </div>
  </div>
</template>

<script>
import RespostaFreteService from '../resposta-frete-service';
import HistoricoDefaultFields from './historico-default-fields';

export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      historicos: [],
      loading: false,
      defaultFields: HistoricoDefaultFields.keys,
    };
  },
  methods: {
    getHistorico() {
      this.loading = true;
      RespostaFreteService.getHistorico(this.resposta.cotacaoFrete.id, this.resposta.id)
        .then(({ data }) => {
          this.historicos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getHistorico();
  },
};
</script>
